<template>
  <div>
    <b-button @click="showModal">Sign</b-button>
    <b-modal
      :no-close-on-backdrop="true"
      :hide-header-close="true"
      :ok-only="true"
      ref="modal"
      id="modal-1"
      title="Sign"
    >
      <div
        class="signature-pad-box"
        style="width: 100%;
  padding-bottom: 20%; position: relative; min-height: 140px"
      >
        <VueSignaturePad
          ref="signaturePad"
          id="sig"
          style="position: absolute; top: 0; left: 0; bottom: 0; right: 0;"
          :options="{onBegin: () => {resizeCanvas()}}"
        />
      </div>
      <div style="margin-bottom: 5px; text-align: center;">
        <b-button>Save</b-button>
        <b-button style="margin-left: 10px; margin-right: 10px" @click="undo">Undo</b-button>
        <b-button @click="clear">clear</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "MySignaturePad",
  data() {
    return {
      _value: ""
    };
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    resizeCanvas() {
      this.$refs.signaturePad.resizeCanvas();
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    isValid() {
      return this._value;
    },
    value() {
      if (!this.isValid()) return "";
      return this._value.replace("data:image/png;base64,", "");
    },
    showModal() {
      this.$refs["modal"].show();
    }
  },
  mounted() {
    let self = this;
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      console.log(self.$refs.signaturePad);
      const { _, data } = this.$refs.signaturePad.saveSignature();
      self._value = data;
      self.data = self.$refs.signaturePad.toData();
    });
    this.$refs.modal.$on("shown", (bvEvent, modalId) => {
      if (self.data) self.$refs.signaturePad.fromData(self.data);
      self.$refs.signaturePad.resizeCanvas();
    });
    self.canvas = document
      .getElementById("sig")
      .getElementsByTagName("canvas")[0];
    console.log(self.canvas);
    document.body.addEventListener(
      "touchstart",
      function(e) {
        if (e.target == self.canvas) {
          e.preventDefault();
        }
      },
      false
    );
    document.body.addEventListener(
      "touchend",
      function(e) {
        if (e.target == self.canvas) {
          e.preventDefault();
        }
      },
      false
    );
    document.body.addEventListener(
      "touchmove",
      function(e) {
        if (e.target == self.canvas) {
          e.preventDefault();
        }
      },
      false
    );
  }
};
</script>
<style>
.signature-pad-box {
  border: solid 1px lightgray;
  margin-bottom: 5px;
}
</style>